import { render, staticRenderFns } from "./material-page.vue?vue&type=template&id=3ccc54b7&scoped=true&"
import script from "./material-page.vue?vue&type=script&lang=js&"
export * from "./material-page.vue?vue&type=script&lang=js&"
import style0 from "./material-page.vue?vue&type=style&index=0&id=3ccc54b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccc54b7",
  null
  
)

export default component.exports